module.exports = __webpack_public_path__ + "img/106.3.ea824502.png";